<template>
  <header
    v-if="!hide"
    class="wet-header"
    :class="{'has-wet-progress': progress, 'has-wet-header-message': $slots.message}"
    @transitionend="setStick"
  >
    <div :class="containered ? 'container-lg' : 'container-fluid'">
      <div class="row header-move">
        <div
          class="col text-center is-size-6 fw-bold empty-ph"
          v-if="title || skeleton && skeleton.includes('title')"
        >{{title}}</div>
        <div class="centered" v-if="menu" :class="smallScreen ? 'col-auto' : 'col-4'">
          <a
            role="button"
            class="wet-menu-toggle"
            @click.prevent="$emit('update:drawer', !drawer)"
          >
            <span></span>
            <span></span>
            <span></span>
          </a>
          <menu-component :menu="menu" horizontal />
        </div>
        <a
          :href="homeLink"
          class="col-auto position-absolute wet-header-icon"
          v-if="homeIcon"
          v-html="homeIcon"
        ></a>
        <div class="centered"
             :class="smallScreen ? 'col' : 'col-4'"
             v-if="logo">
          <div class="row g-0">
            <div class="col text-center">
              <a :href="logo.href">
                <picture>
                  <img
                    :src="logo.image"
                    alt="logo"
                    class="wet-logo"
                    @load="$event.target.classList.toggle('empty-img', false)"
                  >
                </picture>
              </a>
            </div>
            <template v-if="showPartner && partnerLogo.url">
              <div class="col-auto">
                <wet-icon class="wet-icon mx-2 text-secondary" type="plus" />
              </div>
              <div class="col">
                <a href="#" class="">
                  <wp-picture :image="partnerLogo" />
                </a>
              </div>
            </template>
          </div>
        </div>
        <div class="align-self-end centered text-end info-block"
             :class="smallScreen ? 'col-auto' : 'col-4'"
             v-if="(phoneBlock || langs) && checkWindowWidth">
          <div class="flex-row align-items-center justify-content-end">
            <div class="phone-block" v-if="phoneBlock">
              <contact-block
                :icon="phoneBlock.icon"
                :phone="phoneBlock.phone"
                :time="phoneBlock.time"
                :phone_link="phoneBlock.phone_link"
                :time_link="phoneBlock.time_link"
              />
            </div>
            <ul class="wpm-language-switcher switcher-dropdown" v-if="langs">
              <li :class="`item-language-main item-language-${currentLang.lang}`">
                <span>
                  <img v-if="showFlags"
                    :alt="currentLang.title"
                    width="18"
                    height="12"
                    :data-src="currentLang.icon"
                    class="lazyload"
                    :src="currentLang.icon"
                  >
                  <span>{{currentLang.title}}</span>
                </span>
                <ul class="language-dropdown shadow">
                  <li
                    :class="`item-language-${item.lang}`"
                    v-for="(item, id) in langsFiltered"
                    :key="id"
                  >
                    <router-link
                      :to="{params: {lang: getLangAbbr(item)}}"
                      :data-lang="item.lang"
                    >
                      <img v-if="showFlags"
                        width="18"
                        height="12"
                        :alt="item.title"
                        :data-src="item.icon"
                        class="lazyload"
                        :src="item.icon"
                      >
                      <span>{{item.title}}</span>
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="wet-progress" v-if="progress">
        <div
          class="wet-progress-step"
          :class="active > index ? 'active' : ''"
          v-for="(step, index) in Array(progress[1])"
          :key="index"
        ></div>
      </div>
      <slot name="message"></slot>
    </div>
  </header>
</template>
<script>
import { mapState } from 'vuex';
import wpPicture from '@/components/ui/wpPictureUi.vue';
import partnerCodeMixin from '@/mixins/partner-code';
import configEnv from '@/enums/configEnv';
import LogService from '@/services/LogService';
import contactBlock from '@/components/contact/contact-block.vue';
import getLanguageAbbreviation from "@/mixins/getLanguageAbbreviation";
import menuComponent from '@/components/menuComponent.vue';

export default {
  mixins: [partnerCodeMixin, getLanguageAbbreviation],
  props: {
    drawer: Boolean,
    langs: Array,
    menu: Array,
    logo: Object,
    phoneBlock: Object,
    title: String,
    homeIcon: String,
    homeLink: {
      type: String,
      default: `${window.location.origin}/home/${configEnv.default_language}/${configEnv.logo_redirect_page}`,
    },
    containered: Boolean,
    skeleton: Array,
    progress: Array,
    hide: Boolean, /** if true - header will no render */
    showPartner: Boolean, /** show logo of partner */
  },
  components: {
    wetIcon: () => import('@/components/wetIcon.vue'),
    contactBlock,
    wpPicture,
    menuComponent,
  },
  data() {
    return {
      showFlags: configEnv.showFlags,
      active: 0,
      checkWindowWidth: window.innerWidth >= 768,
      smallScreen: window.innerWidth <= 576,
    };
  },
  computed: {
    ...mapState(['strings']),
    currentLang() {
      LogService.log('phoneBlock r', this.phoneBlock);
      const current = this.$route.params.lang ? this.$route.params.lang.toLowerCase() : 'en';
      LogService.log('currentLang', current, this.langs);
      LogService.log('showFlags', this.showFlags);
      return this.langs.filter((el) => el.lang === current)[0];
      // return this.$_.filter(this.langs, { 'lang': current})[0]
    },
    langsFiltered() {
      LogService.log('currently available langs', this.langs);
      const current = this.$route.params.lang ? this.$route.params.lang.toLowerCase() : 'en';
      return this.langs.filter((el) => el.lang !== current);
      // return this.$_.reject(this.langs, { 'lang': current})
    },
    partnerLogo() {
      let logo = {};
      // get partner code
      const { partnerCode } = this;

      // get logo
      if (partnerCode && partnerCode !== 'wetterheld') {
        const partners = this.strings.commonApp?.partners;
        const partner = Array.isArray(partners)
          ? partners.filter((p) => p.partner_code === partnerCode)[0]
          : undefined;
        if (partner) logo = partner.logo;
      }
      return logo;
    },
  },
  watch: {
    progress: {
      immediate: true,
      handler(p) {
        if (p?.[0]) [this.active] = p;
      },
    },
  },
  mounted() {
    // set stick padding
    this.setStick();
    window.addEventListener('resize', this.onResize);
    this.$root.$on('resize', this.resize);
    this.$root.$on('scroll', this.scroll);
  },
  destroyed() {
    // unwatch
    window.removeEventListener('resize', this.onResize);
    this.$root.$off('resize', this.resize);
    this.$root.$off('scroll', this.scroll);

    // document.documentElement.style.setProperty('--header-height', '0px');
  },
  updated() {
    this.setStick();
  },
  methods: {
    onResize() {
      LogService.log('windowWidth', window.innerWidth);
      this.checkWindowWidth = window.innerWidth >= 768;
      this.smallScreen = window.innerWidth <= 576;
    },
    setStick() {
      // set the header sticky & change header-height css var
      if (document) {
        const header = document.querySelector('.wet-header');
        const root = document.documentElement;
        let h = '0px';
        if (header) {
          // set header-height css var
          h = this.hide ? '0px' : `${header.offsetHeight}px`;
          root.style.setProperty('--header-height', h);
          const next = header.nextSibling;
          if ('getBoundingClientRect' in next) {
            const offset = next.getBoundingClientRect().top;
            if (Math.abs(offset) > 0) {
              header.classList.toggle('stick', true);
            } else header.classList.toggle('stick', false);
          }
        }
        root.style.setProperty('--header-height', h);
      }
    },
    resize() {
      // call on event window.resize
      this.setStick();
    },
    scroll() {
      // call on event window.scroll
      this.setStick();
    },
  },
};
</script>
<style lang="scss">
  .wet-header {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 9;
    border-bottom: 1px solid transparent;
  }
  .wet-header.has-wet-header-message {
    box-shadow: 0 1rem 1rem rgba(0,0,0,.1);
  }
  .wet-header.stick {
    background-color: rgba(255, 255, 255, 0.9);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    border-color: #EFF2F5;
  }
  .wet-header .container, .container-lg, .wet-header .container-fluid {
    // max-width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 20px;
    padding-left: 20px;
  }
  @media only screen and (max-width: 1200px) {
    .wet-header .container, .wet-header .container-fluid {
      padding: 10px;
    }
  }
  @media only screen and (max-width: 768px) {
    .wet-header .wet-nav {
      display: none;
    }
  }
  @media only screen and (max-width: 768px) {
    .wet-header .wet-button.wet-button-small {
      padding: 3px 0 0;
      background-color: transparent;
      -webkit-box-shadow: none;
      box-shadow: none;
      font-weight: 600;
      white-space: nowrap;
    }
    .wet-button-dropdown-current{
      color: var(--primary);
    }
  }
  .wet-nav-list li {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }
  .wet-nav-list li:not(:last-child) {
    margin-right: 30px;
  }
  .wet-nav-list li a:hover {
    color: var(--primary);
  }
  .wet-header-icon svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: var(--septenary);
  }
  .wet-logo{
    float: left;
    max-height: 50px;
  }

  .centered{
    margin-bottom: auto;
    margin-top: auto;
  }

  /* Lang */
  header .wpm-language-switcher{
    display: block;
    z-index: 99;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    margin-left: 15px;
    position: relative;
  }
  header .wpm-language-switcher:before{
      content: "";
      width: 20px;
      height: 20px;
      background-image: url("~@/assets/images/svg/arrow-down.svg");
      background-position: center center;
      background-size: 10px;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translate(0, -50%);
      transition: all ease 0.2s;
  }
  header .wpm-language-switcher:hover:before{
    transition: all ease 0.2s;
    transform: translate(0, -50%) rotate(-180deg);
  }
  .wet-header.has-wet-progress {
    border-bottom: none;
  }
  .wet-progress {
    display: flex;
    margin-top: 15px;
    margin-bottom: -16px;
  }
  .wet-progress-step {
    flex: 1;
    height: 3px;
    background: linear-gradient(90deg, var(--primary) 0%, var(--primary) 49%, #cccccc 50%);
    background-size: 210% 100%;
    background-position-x: 100%;
    transition: 1s all;
  }
  @media only screen and (max-width: 1200px) {
    .wet-progress {
      margin-top: 10px;
      margin-bottom: -11px;
    }
    .wet-progress-step {
      height: 2px;
    }
  }
  .wet-progress-step:not(:last-child) {
    margin-right: .5rem;
  }
  .wet-progress-step.active {
    background-position-x: 1%;
  }
  .wet-header-message {
    margin-top: 15px;
    margin-bottom: -16px;
  }
  @media only screen and (max-width: 1200px) {
    .wet-header-message {
      margin-top: 10px;
      margin-bottom: -11px;
    }
  }

  .menu-item-has-children ul.sub-menu {
    display: none;
    padding: 0.5rem 1rem 0 0;
    list-style: none;
    position: absolute;
    margin: 0px 0px;
    border-radius: 0.5rem;
  }

  .menu-item-has-children ul.sub-menu li {
    background-color: white;
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    min-width: 100%;
    border-left: 1px solid var(--gray-light);
    border-right: 1px solid var(--gray-light);
    box-sizing: content-box;
  }

  .menu-item-has-children ul.sub-menu li:first-child {
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
    padding-top: .5rem;
    border-top: 1px solid var(--gray-light);
  }

  .menu-item-has-children ul.sub-menu li a {
    display: block;
    white-space: nowrap;
  }

  .menu-item-has-children ul.sub-menu li:last-child {
    border-bottom-left-radius: .5rem;
    border-bottom-right-radius: .5rem;
    padding-bottom: .5rem;
    border-bottom: 1px solid var(--gray-light);
  }

  .menu-item-has-children ul.sub-menu:hover {
    display: block;
  }

  .menu-item-has-children:hover ul.sub-menu {
    display: block;
  }
</style>
